import { Addr } from "src/app/shared/model/addr.model";

export class CustomerProfile {
	public loginId: string;
	public password: string;
	public confirmPassword: string;
	public personId: number;
	public firstName: string;
	public lastName: string;
	public emailVerificationCode: String;


	middleName: string;
	nickName: string;
	salutation: string;
	gender: string;
	ssn: string;
	taxId: string;

	//Phones
	primaryPhoneCountryCode: number;
	primaryPhone: string;
	altPhoneCountryCode: number;
	altPhone: string;

	homeOrOfficeAddress: Addr;
	mailingOrShippingAddress: Addr;

	// Flat fields to match backend
	billingAddressLine1: string;
	billingAddressLine2: string;
	billingCity: string;
	billingStateOrProvince: string;
	billingCountry: string;
	billingZipOrPostalCode: string;
	billingCounty: string;
	billingCountryId: number;
	billingStateOrProvinceId: number;

	shippingAddressLine1: string;
	shippingAddressLine2: string;
	shippingCity: string;
	shippingStateOrProvince: string;
	shippingCountry: string;
	shippingZipOrPostalCode: string;
	shippingCounty: string;
	shippingCountryId: number;
	shippingStateOrProvinceId: number;

	caid: number;
	shard: number;

	constructor() {
		this.homeOrOfficeAddress = new Addr();
		this.mailingOrShippingAddress = new Addr();
		this.mailingOrShippingAddress.countryId = 231;
		this.homeOrOfficeAddress.countryId = 231;
	}

}
